import { AbstractApiService } from "../abstractions/AbstractApiService";
import { OnRequestSuccess, OnRequestError } from "./Responses";
import { IInternship } from "../models/IInternship";

export class InternshipService extends AbstractApiService {
    constructor() {
        super();
    }

    public GetMyInternships(onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/internship/myinternships', onSuccess, onError);
    }

    public AddMyInternship(model: IInternship, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/internship/addmyinternship', model, onSuccess, onError);
    }

    public EditMyInternship(model: IInternship, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/internship/editmyinternship', model, onSuccess, onError);
    }

    public RemoveMyInternship(educationId: number, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/internship/removemyinternship', educationId, onSuccess, onError);
    }

    public GetPhysiotherapistsInternships(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/internship/getphysiotherapistsinternships?physiotherapistId=' + physiotherapistId,
            onSuccess,
            onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/InternshipService.tsx